/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Prices_CalculatedInputs */

const en_field_prices_calculated = /** @type {(inputs: Field_Prices_CalculatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prices calculated`)
};

/**
* | output |
* | --- |
* | "Prices calculated" |
*
* @param {Field_Prices_CalculatedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_prices_calculated = /** @type {((inputs?: Field_Prices_CalculatedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Prices_CalculatedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_prices_calculated(inputs)
});